/** Account API paths, relative to `VITE_API_BASE_URL`. */
export const accountEndpoints = {
  currentUser: '/user/current',
} as const;
